export default __webpack_public_path__ + "static/media/3.fab8cc84.svg";